import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import EnTranslation from "./locales/EN.json";
import DeTranslation from "./locales/DE.json";
import FrTranslation from "./locales/FR.json";

const local = localStorage.getItem("locale") || "en";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: EnTranslation },
    de: { translation: DeTranslation },
    fr: { translation: FrTranslation },
  },
  lng: local,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
